import React, { useState, useEffect } from "react";
import "../../App.css";
import { mockData } from "../../components/Constant";
import FormContainer from "../../components/FormContainer";
import FormProvider from "../../context/FormContext";
import useForm from "../../hooks/useForm";
import ErrorScreen from "../../screens/ErrorScreen";
import LoadingScreen from "../../screens/LoadingScreen";
import { getFormName } from "../../utils/constants";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./MdaForm.module.css";



const MdaForm = () => {
  const { merchant, data, fetching, error, fetch, fetchMdaForm } = useForm();
  const navigate = useNavigate();
  const { state } = useLocation();

  const formName = state && state.formName;
  const selectedOption = state && state.selectedOption;
  const accessToken = state && state.accessToken;
  const mdaRequester = state && state?.mda;

  const goBack = () => {
    navigate(-1);
  };

  // useEffect(() => {
  //   fetch();
  // }, []);

  useEffect(() => {
    fetchMdaForm(selectedOption.tenantId, formName);
  }, []);

  useEffect(() => {
    document.title = getFormName();
  }, [document]);

  if (fetching && !data) {
    return <LoadingScreen />;
  }

  if (!fetching && error) {
    return <ErrorScreen message={"Unable to load form!"} refetch={fetch} />;
  }
  if (
    !fetching &&
    !error &&
    data &&
    (!data.data[0].form_fields || data.data[0].form_fields.length === 0)
  ) {
    return <ErrorScreen message={"Form not found!"} refetch={fetch} />;
  }

  return (
    <div className="container">
      <div className="goBack" onClick={goBack}>
        <img
          src="https://res.cloudinary.com/dso7hgghd/image/upload/v1705918242/back_no6tw3.png"
          width={26}
          alt="Go back"
          onClick={goBack}
        />{" "}
        <span className="backText">Inter MDA Form</span>
      </div>
      {!fetching && !error && data && (
        <FormProvider {...{ ...data.data[0], merchant, accessToken,selectedOption, mdaRequester }}>
          <FormContainer />
        </FormProvider>
      )}
    </div>
  );
};

export default MdaForm;
